import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import HouseProgressBar from "@/components/subcomponents/HouseProgressBar";
import { useTitle } from "@/components/provider/TitleProvider";
import { useSubHeader } from "@/components/provider/SubHeaderProvider";
import TransitionLink from "../../TransitionLink";

const MonthlyBoost = () => {
  const { setTitle } = useTitle();
  const { setSubHeader } = useSubHeader();

  useEffect(() => {
    setTitle("BuySooner - Monthly Boost", "center");

    setSubHeader(
      <div className="mt-12 text-center pb-4">
        <TransitionLink
          to="/monthly-boost/calculator"
          onClick={() => setSubHeader(<></>)}
          className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
        >
          See calculation for your home
        </TransitionLink>
      </div>,
    );
  }, []);
  useEffect(() => {
    const body = document.querySelector("#root")!;
    body.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-5 sm:grid-rows-[auto_auto_auto] gap-x-4 max-w-5xl mx-auto py-8">
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Monthly home loan repayments</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={50}
          fillColor="#57CB8F"
          baseColor="#2E3745"
          shares={{
            variant: 1,
            percentageOne: 50,
            percentageTwo: 50,
          }}
          shareLabels={{
            labelOne: "BuySooner",
            labelTwo: "Owner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          BuySooner shares repayments for 3 years so you don’t need to struggle. We take a small piece of ownership for
          this, that is generally less than 1 year’s capital gains on your home.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Shared Ownership</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={80}
          fillColor="#57CB8F"
          baseColor="#2E3745"
          shares={{
            variant: 2,
            percentageOne: 95,
            percentageTwo: 5,
          }}
          shareLabels={{
            labelOne: "Owner",
            labelTwo: "5% BuySooner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          We will help you get a refinance so you can buy back our share. You can also contribute a small amount monthly
          to progressively buy back our share.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">100% Self Owned</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={100}
          fillColor="#2E3745"
          baseColor="#2E3745"
          shares={{
            variant: 3,
            percentageOne: 100,
            percentageTwo: 0,
          }}
        />
      </div>
    </div>
  );
};

MonthlyBoost.propTypes = {};

export default MonthlyBoost;
